module.exports = __webpack_public_path__ + "static/img/111.3140117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/111.png
// module id = t1Cs
// module chunks = 8